module.exports = __webpack_public_path__ + "img/7A9196_485C64_425459_C1E4E7-256px.a7d36279.png";